var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Select } from 'shared-assets/components/Elements';
import { Typography, Button, Tabs, Tab, Box, IconButton, LeftCaretIcon, RightCaretIcon, Tooltip, palette, List, } from '@kareo/design-system';
import { updateClearedRecommendations } from 'shared-assets/facesheet-ui/service/facesheet/service';
import ModalCard from 'shared-assets/components/Modal/ModalCard';
import { Grid } from '@material-ui/core';
import parse from 'html-react-parser';
// @ts-ignore
import LinesEllipsis from 'react-lines-ellipsis';
import rollbar from 'shared-assets/src/errors/errors';
import { ClearedRecommendation, clearedRecommendationIntervals, } from 'shared-assets/facesheet-ui/service/facesheet/types';
var RecommendationsModal = function (_a) {
    var selectedId = _a.selectedId, patientId = _a.patientId, recommendations = _a.recommendations, isModalOpen = _a.isModalOpen, closeModal = _a.closeModal, updateDismissedRecommendationIds = _a.updateDismissedRecommendationIds;
    var _b = useState(''), title = _b[0], setTitle = _b[1];
    var _c = useState(''), grade = _c[0], setGrade = _c[1];
    var _d = useState(''), text = _d[0], setText = _d[1];
    var _e = useState(''), frequency = _e[0], setFrequency = _e[1];
    var _f = useState(''), risk = _f[0], setRisk = _f[1];
    var _g = useState(''), clinicalText = _g[0], setClinicalText = _g[1];
    var _h = useState(''), rationale = _h[0], setRationale = _h[1];
    var _j = useState(0), index = _j[0], setIndex = _j[1];
    var _k = useState(0), total = _k[0], setTotal = _k[1];
    var _l = useState(0), currentValue = _l[0], setValue = _l[1];
    var _m = useState(false), isCDSAlert = _m[0], setIsCDSAlert = _m[1];
    var _o = useState(''), biblio = _o[0], setBiblio = _o[1];
    var _p = useState(0), id = _p[0], setId = _p[1];
    var _q = useState(0), dismissedInterval = _q[0], setDismissedInterval = _q[1];
    var _r = useState([]), dismissedRecommendations = _r[0], setDismissedRecommendations = _r[1];
    var WarningTypography = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    & {\n      color: ", ";\n    }\n  "], ["\n    & {\n      color: ", ";\n    }\n  "])), palette.warning.main);
    var StyledList = styled(List)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &&& {\n      padding: 0;\n      margin: 0;\n    }\n  "], ["\n    &&& {\n      padding: 0;\n      margin: 0;\n    }\n  "])));
    var StyledButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &&& {\n      margin: 0 0 0 20px;\n    }\n  "], ["\n    &&& {\n      margin: 0 0 0 20px;\n    }\n  "])));
    var StyledSelect = styled(Select)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    &&& {\n      margin: 0 0 0 10px;\n    }\n  "], ["\n    &&& {\n      margin: 0 0 0 10px;\n    }\n  "])));
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var getRecommendation = function () {
        var index = recommendations.findIndex(function (rec) { return rec.id === selectedId; });
        if (index > -1) {
            setRecommendationText(index);
        }
    };
    var setRecommendationText = function (index) {
        var recommendation = recommendations[index];
        var isCDS = !!recommendation.biblio && recommendation.grade === '!';
        setTitle(recommendation.title);
        setGrade(recommendation.grade);
        setText(recommendation.text);
        setFrequency(recommendation.servFreq);
        setRisk(recommendation.riskText);
        setClinicalText(recommendation.clinicalText);
        setRationale(recommendation.rationale);
        setIndex(index);
        setTotal(recommendations.length);
        setIsCDSAlert(isCDS);
        setBiblio(recommendation.biblio);
        if (isCDS) {
            setValue(0);
        }
        setId(recommendation.id);
        setDismissedInterval(getDismissedInterval(recommendation.id));
    };
    var parseHtml = function (html) {
        try {
            return parse(html);
        }
        catch (error) {
            rollbar.error(error);
            return html;
        }
    };
    var handleDismissIntervalChange = function (event) {
        var dismissInterval = event.target.value || 0;
        if (dismissInterval) {
            var interval = parseInt(dismissInterval);
            setDismissedInterval(interval);
            var dismissedRecommendation = new ClearedRecommendation(id, interval, title);
            dismissedRecommendations.push(dismissedRecommendation);
        }
    };
    var undoDismissal = function () {
        setDismissedInterval(0);
        var dismissedArray = __spreadArrays(dismissedRecommendations);
        var updatedArray = dismissedArray.filter(function (clearedRec) { return clearedRec.id !== id; });
        setDismissedRecommendations(updatedArray);
    };
    var getDismissedInterval = function (recommendationId) {
        var dismissedRecommendation = dismissedRecommendations.find(function (clearedRec) { return clearedRec.id === recommendationId; });
        if (dismissedRecommendation) {
            return dismissedRecommendation.clearedInterval;
        }
        else {
            return 0;
        }
    };
    var closeAndUpdateModal = function () {
        if (dismissedRecommendations.length > 0) {
            var dismissedIds_1 = new Set();
            dismissedRecommendations.forEach(function (recommendation) {
                dismissedIds_1.add(recommendation.id);
            });
            updateClearedRecommendations(patientId, dismissedRecommendations)
                .then(function () {
                updateDismissedRecommendationIds(dismissedIds_1);
            })
                .catch(function (error) { return rollbar.error(error); });
        }
        closeModal();
    };
    useEffect(function () {
        if (selectedId && recommendations.length > 0) {
            getRecommendation();
        }
    }, [selectedId]);
    return (React.createElement(ModalCard, { open: isModalOpen, header: isCDSAlert ? 'CDS Alert' : 'Clinical Recommendations', footer: React.createElement(Grid, { container: true, justify: "space-between" },
            React.createElement(Grid, { item: true, container: true, alignItems: "center", xs: 6 },
                React.createElement(Grid, { item: true }, dismissedInterval > 0 && (React.createElement(WarningTypography, { component: "div" },
                    "This recommendation has been dismissed for ",
                    dismissedInterval,
                    ' ',
                    "months")))),
            React.createElement(Grid, { item: true, container: true, justify: "flex-end", alignItems: "center", xs: 6 },
                React.createElement(Grid, { item: true },
                    React.createElement(Button, { color: "vitality", size: "small", onClick: closeAndUpdateModal },
                        React.createElement(Typography, { component: "div" }, "Done"))))), onClose: closeModal, size: "large" },
        React.createElement(Grid, { container: true, direction: "column" },
            React.createElement(Grid, { item: true },
                React.createElement(Box, { height: "4rem" },
                    React.createElement(Typography, { variant: "h3", component: "div" },
                        React.createElement(Tooltip, { title: title },
                            React.createElement(LinesEllipsis, { text: title, maxLine: 2 }))))),
            React.createElement(Grid, { item: true },
                React.createElement(Typography, { variant: "h4", component: "div" }, isCDSAlert ? 'Preventive Care and Screening:' : "Grade: " + grade)),
            React.createElement(Grid, { item: true },
                React.createElement(Box, { boxSizing: "border-box", p: 1, border: 1, borderColor: "background.default", height: "7rem", overflow: "auto" },
                    !isCDSAlert && (React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "h4", component: "div" }, "Recommendation:"))),
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body1", component: "div" }, text && parseHtml(text))))),
            React.createElement(Grid, { item: true },
                React.createElement(Tabs, { value: currentValue, onChange: handleChange },
                    React.createElement(Tab, { label: "General" }),
                    !isCDSAlert && React.createElement(Tab, { label: "Clinical Considerations" }),
                    !isCDSAlert && React.createElement(Tab, { label: "Rationale" })),
                React.createElement(Box, { boxSizing: "border-box", p: 1, border: 1, borderColor: "background.default", height: "18rem", overflow: "auto" },
                    currentValue === 0 && (React.createElement(Grid, { container: true, direction: "column", spacing: 1 }, isCDSAlert ? (React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { variant: "h4", component: "div" }, "Diagnostic and Therapeutic Reference Resources:")),
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { variant: "body1", component: "div" }, biblio && parseHtml(biblio))))) : (React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { variant: "h4", component: "div" }, "Frequency of Service:"),
                            React.createElement(Typography, { variant: "body1", component: "div" }, frequency ? (parseHtml(frequency)) : (React.createElement(Typography, { color: "error", component: "div" }, "No Frequency of Service information is available.")))),
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { variant: "h4", component: "div" }, "Risk Factor Information:"),
                            React.createElement(Typography, { variant: "body1", component: "div" }, risk ? (parseHtml(risk)) : (React.createElement(Typography, { color: "error", component: "div" }, "No Risk Factor Information is available.")))))))),
                    currentValue === 1 && (React.createElement(Typography, { variant: "body1", component: "div" }, parseHtml(clinicalText))),
                    currentValue === 2 && (React.createElement(Typography, { variant: "body1", component: "div" }, parseHtml(rationale)))))),
        React.createElement(Box, { mt: "1rem" },
            React.createElement(Grid, { container: true, justify: "space-between" },
                React.createElement(Grid, { item: true, container: true, alignItems: "center", xs: 6 }, !isCDSAlert && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body1", component: "div" }, "Dismiss for")),
                    React.createElement(Grid, { item: true },
                        React.createElement(StyledSelect, { value: dismissedInterval, onChange: function (event) { return handleDismissIntervalChange(event); } }, clearedRecommendationIntervals.map(function (option) { return (React.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
                    React.createElement(Grid, { item: true }, dismissedInterval > 0 && (React.createElement(StyledButton, { onClick: function () { return undoDismissal(); } }, "Undo")))))),
                React.createElement(Grid, { item: true, container: true, justify: "flex-end", alignItems: "center", xs: 6 },
                    React.createElement(Grid, { item: true },
                        React.createElement(IconButton, { size: "medium", onClick: function () { return setRecommendationText(index - 1); }, disabled: index === 0 },
                            React.createElement(LeftCaretIcon, null))),
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body1", component: "div" }, index + 1 + " of " + total)),
                    React.createElement(Grid, { item: true },
                        React.createElement(IconButton, { size: "medium", onClick: function () { return setRecommendationText(index + 1); }, disabled: index + 1 === recommendations.length },
                            React.createElement(RightCaretIcon, null))))))));
};
export default RecommendationsModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
